export const sleepingRooms: {
    label: string;
    criterias: string[];
}[] = [
    {
        label: '5',
        criterias: ['323']
    },
    {
        label: '6',
        criterias: ['324']
    },
    {
        label: '7',
        criterias: ['325']
    },
    {
        label: '8',
        criterias: ['326']
    },
    {
        label: '9',
        criterias: ['327']
    },
    {
        label: '10',
        criterias: ['328']
    },
    {
        label: '11',
        criterias: ['329']
    },
    {
        label: '12',
        criterias: ['330']
    },
    {
        label: '13',
        criterias: ['331']
    },
    {
        label: '14',
        criterias: ['332']
    },
    {
        label: '15',
        criterias: ['333']
    },
    {
        label: '16',
        criterias: ['334']
    },
    {
        label: '17',
        criterias: ['335']
    },
    {
        label: '18',
        criterias: ['336']
    },
    {
        label: '19',
        criterias: ['337']
    },
    {
        label: '20',
        criterias: ['338']
    }
]